const prefixName = 'PEOPLE_TYPES_';

export const PEOPLE_TYPES_FAILURE = `${prefixName}FAILURE`;
export const PEOPLE_TYPES_FETCHING = `${prefixName}FETCHING`;
export const PEOPLE_TYPES_SEARCH = `${prefixName}SEARCH`;
export const PEOPLE_TYPES_SUCCESS = `${prefixName}SUCCESS`;
